module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-zertifizierung-5c67576cf616d94283a0b8470a55d4bb.svg";